import { createContext, useContext } from 'react';
import { useServiceOrderModal } from '../hooks/useServiceOrderModal';

type ServiceOrderContextType = ReturnType<typeof useServiceOrderModal>;

const ServiceOrderContext = createContext<ServiceOrderContextType | undefined>(
    undefined,
);

// eslint-disable-next-line react-refresh/only-export-components
export const useServiceOrderContext = () => {
    const context = useContext(ServiceOrderContext);
    if (!context) throw new Error('Must be used within ServiceOrderProvider');
    return context;
};

export const ServiceOrderProvider = ServiceOrderContext.Provider;
